module.exports = __webpack_public_path__ + "static/media/edit-picture.21694fd0.svg";